import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { getCurrentStreamItems, getIsShowingAddDeviationsPopup } from '../../selectors';
import { addDeviations, showAddDeviationsPopup, hideAddDeviationsPopup } from '../../actions';
const mapStateToProps = (state)=>({
        currentDeviationIds: getCurrentStreamItems(state),
        isShowingAddDeviationsPopup: getIsShowingAddDeviationsPopup(state)
    });
const mapDispatchToProps = {
    addDeviations,
    showAddDeviationsPopup,
    hideAddDeviationsPopup
};
export default connectMediaStore(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=AddDeviationsButton.container.js.map